import React, { Component } from 'react';
import { Modal, Form, FormGroup, ControlLabel, FormControl, Checkbox, HelpBlock, Button, ButtonToolbar } from 'react-bootstrap';
import Select from "react-select";
import { SketchPicker } from 'react-color';

import { SelectOptionsHelper } from '../../helpers/SelectOptionsHelper';

export class PathActiveForm extends Component {
    render() {
        const { show, form, line } = this.props;

        if (undefined === form || undefined === form.obj) {
            return null;
        }

        return (
            <Modal show={show}>
                <Modal.Header>
                    <Modal.Title>
                        {form.title}
                    </Modal.Title>
                </Modal.Header>
                <Modal.Body>
                    <Form>
                        <FormGroup controlId="formLine">
                            <ControlLabel>Linha</ControlLabel>

                            <FormControl
                                disabled
                                placeholder={undefined !== line ? line.code : ''}
                            />
                        </FormGroup>
                        <FormGroup controlId="formCode" validationState={form.codeInputError} >
                            <ControlLabel>Código</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.code}
                                placeholder="Introduza o código"
                                onChange={(e) => this.props.onChangeValue(e, "code")}
                            />
                            {form.codeInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="formExtCode">
                            <ControlLabel>Código Externo</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.extCode}
                                placeholder="Introduza a o código externo"
                                onChange={(e) => this.props.onChangeValue(e, "extCode")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formIsTourist">
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={form.obj.isTourist}
                                onChange={(e) => this.props.onCheckValue(e, "isTourist")}>
                                Percurso Turístico
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formInSpine">
                            <Checkbox
                                className="form-checkbox"
                                defaultChecked={form.obj.inSpine}
                                onChange={(e) => this.props.onCheckValue(e, "inSpine")}>
                                Presente na Espinha
                            </Checkbox>
                        </FormGroup>

                        <FormGroup controlId="formOrientation" validationState={form.orientationInputError} >
                            <ControlLabel>Orientação</ControlLabel>
                            <Select
                                className="custom-multiselect"
                                placeholder="Selecione uma orientação..."
                                noOptionsMessage={() => "Sem Orientações Configuradas"}
                                onChange={(e) => this.props.onSelectValue(null === e ? undefined : e.orientation, "orientation")}
                                options={SelectOptionsHelper.PathOrientations}
                                isMulti={false}
                                isClearable={true}
                                getOptionValue={value => value.orientation}
                                getOptionLabel={label => label.label}
                                value={SelectOptionsHelper.PathOrientations.find(x => x.orientation === form.obj.orientation)}
                            />
                            {form.orientationInputError !== null
                                ?
                                <HelpBlock> Este campo não pode estar vazio. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>

                        <FormGroup controlId="fromPriority" validationState={form.priorityInputError}>
                            <ControlLabel>Prioridade</ControlLabel>
                            <FormControl
                                type="number"
                                min="0"
                                value={form.obj.priority}
                                placeholder="Introduza prioridade (0 = maior prioridade)"
                                onChange={(e) => this.props.onChangeValue(e, "priority")}
                            />
                            {form.priorityInputError !== null
                                ?
                                <HelpBlock> Introduza um valor positivo. </HelpBlock>
                                :
                                null
                            }
                        </FormGroup>
                        <FormGroup controlId="formExtCode">
                            <ControlLabel>Descrição</ControlLabel>
                            <FormControl
                                type="text"
                                value={form.obj.description}
                                placeholder="Introduza a descrição"
                                onChange={(e) => this.props.onChangeValue(e, "description")}
                            />
                        </FormGroup>

                        <FormGroup controlId="formIsDescriptionProvisional">
                            <Checkbox
                                className="form-checkbox"
                                checked={form.obj.isDescriptionProvisional}
                                onChange={(e) => this.props.onCheckValue(e, "isDescriptionProvisional")}>
                                Descrição Provisória
                            </Checkbox>
                        </FormGroup>

                        {form.obj.isDescriptionProvisional &&
                            <FormGroup controlId="formProvisionalColor">
                                <ControlLabel>Cor Provisória</ControlLabel>
                                <SketchPicker
                                    className="sketch-picker"
                                    disableAlpha
                                    color={form.obj.provisionalColor}
                                    onChangeComplete={(color) => this.props.onSelectValue(color.hex, "provisionalColor")}
                                />
                            </FormGroup>
                        }
                    </Form>
                    <ButtonToolbar>
                        <Button onClick={this.props.onSave}> GUARDAR ALTERAÇÕES </Button>
                        <Button onClick={this.props.onHide}> CANCELAR </Button>
                    </ButtonToolbar>
                </Modal.Body>
            </Modal>
        );
    }
}
